import * as v from 'valibot';
export const zigbeeGUILevelSchema = v.object({
    min: v.number(),
    max: v.number(),
});
